import Api from '@topomatic/tap/src/api';
import { UAParser } from 'ua-parser-js';

export default class FilesApi extends Api {
    constructor() {
        super();
        this.autologin = false;
        this.observers = {};
        this.reconectWs();
    }

    createWs() {
        let uri = this.api_root;
        let index = uri.indexOf('://');
        if (index < 0) {
            uri = window.location.origin + uri;
            index = uri.indexOf('://');
        }
        const schema = uri.substring(0, index);
        if (schema === 'http') {
            uri = `ws://${uri.substring(index + 3)}`;
        } else {
            uri = `wss://${uri.substring(index + 3)}`;
        }
        const socket = new WebSocket(`${uri}/observer`);
        socket.onopen = () => {
            this.wsLogin();
        };
        socket.onmessage = (e) => {
            if (e == null) {
                return;
            }
            try {
                const message = JSON.parse(e.data);
                const { event } = message;
                this.wsNotify(event, message);
                if (event === 'logout') {
                    if (this.authorized) {
                        // todo
                    }
                }
            } catch {
                console.log(e.data);
            }
        };
        socket.onclose = (event) => {
            setTimeout(() => {
                this.reconectWs();
            }, event.wasClean ? 1000 : 500);
        };
        socket.onerror = (e) => {
            console.log(e);
            if (socket.readyState === 1) {
                socket.close();
            }
        };
        return socket;
    }

    reconectWs() {
        this.socket = this.createWs();
    }

    wsSend(msg) {
        if (this.socket.readyState === 1) {
            this.socket.send(JSON.stringify(msg));
        } else {
            console.warn('sock not ready');
        }
    }

    wsLogin() {
        if (this.authorized) {
            const { me } = this;
            const parser = UAParser();
            const { browser } = parser;
            const { os } = parser;
            this.wsSend({
                event: 'login',
                type: me.token_type,
                token: me.access_token,
                client: `${browser.name} ${browser.version}`,
                device: `${os.name} ${os.version}`,
            });
        }
    }

    wsLogout() {
        this.wsSend({
            event: 'logout',
        });
    }

    wsRegister(event, observer) {
        const collection = this.observers[event];
        if (collection == null) {
            this.observers[event] = [observer];
        } else {
            collection.push(observer);
        }
    }

    wsUnregister(event, observer) {
        const collection = this.observers[event];
        if (collection != null) {
            const index = collection.indexOf(observer);
            if (index >= 0) {
                collection.splice(index, 1);
            }
        }
    }

    wsNotify(event, msg) {
        const collection = this.observers[event];
        if (collection != null) {
            for (const observer of collection) {
                observer(msg);
            }
        }
    }

    getShareFile(share_id) {
        return this.get_json(`/share?id=${share_id}`);
    }

    shareFile(id, password = undefined, hidden = false, days_expire_in = 0, permissions = 7) {
        let url = `/share?id=${id}&expired=${Math.round(days_expire_in)}&hidden=${hidden ? 1 : 0}&permissions=${permissions}`;
        if (password !== undefined) {
            url += `&password=${password}`;
        }
        return this.post_json(url);
    }

    updateShare(share_id, file_id, password = undefined, days_expire_in = undefined, permissions = undefined) {
        let url = `/share?share_id=${share_id}&id=${file_id}`;
        if (password !== undefined) {
            url += `&password=${password}`;
        }
        if (days_expire_in !== undefined) {
            url += `&expired=${Math.round(days_expire_in)}`;
        }
        if (permissions !== undefined) {
            url += `&permissions=${permissions}`;
        }
        return this.put_json(url);
    }

    removeShare(fid) {
        return this.delete(`/share?id=${fid}`);
    }

    changeFileDescription(id, description) {
        return this.post_json(`/file?id=${id}&description=${description}`);
    }

    addDrive(name, company) {
        if (company != null) {
            return this.post_json(`/file?name=${name}&type=application/vnd.folder&company=${company}`);
        }
        return this.post_json(`/file?name=${name}&type=application/vnd.folder`);
    }

    addFolder(name, parent) {
        return this.post_json(`/file?name=${name}&type=application/vnd.folder&parent=${parent}`);
    }

    uploadFile(parent, name, type, body, progress, revisions = false, path = false) {
        return this.upload('POST', `/file?name=${name}&type=${type}&parent=${parent}&revisions=${revisions ? 1 : 0}&path=${path ? 1 : 0}`, body, progress);
    }

    createFile(name, parent, type) {
        return this.post_json(`/file?name=${name}&type=${type}&parent=${parent}`);
    }

    updateFile(id, body, progress, revisions = false, path = false) {
        return this.upload('POST', `/file?id=${id}&revisions=${revisions ? 1 : 0}&path=${path ? 1 : 0}`, body, progress);
    }

    downloadFile(id, revision) {
        if (revision == null) {
            return this.get(`/file?type=data&id=${id}`, {
                Mode: 'direct',
            });
        }
        return this.get(`/file?type=data&id=${id}&revision=${revision}`, {
            Mode: 'direct',
        });
    }

    renameFile(id, name) {
        return this.post_json(`/file?id=${id}&name=${name}`);
    }

    removeFile(id) {
        return this.delete(`/file?id=${id}`);
    }

    restoreFile(id) {
        return this.post(`/restore?id=${id}`);
    }

    revokeDrive(id) {
        return this.delete(`/permissions?id=${id}`);
    }

    getFile(id, revisions = false, path = false, share = false) {
        return this.get_json(`/file?id=${id}&revisions=${revisions ? 1 : 0}&path=${path ? 1 : 0}&type=metadata&share=${share ? 1 : 0}`);
    }

    getFiles(parent, depth = 0, path = true, trashed = false, share = false) {
        if (depth == null) {
            return this.get_json(`/files?parent=${parent}&path=${path ? 1 : 0}&trashed=${trashed ? 1 : 0}&share=${share ? 1 : 0}`);
        }
        return this.get_json(`/files?parent=${parent}&depth=${depth}&path=${path ? 1 : 0}&trashed=${trashed ? 1 : 0}&share=${share ? 1 : 0}`);
    }

    lockFile(file, scope, revisions = false, path = false) {
        return this.fetch_json('LOCK', `/file?id=${file}&scope=${encodeURIComponent(scope)}&revisions=${revisions ? 1 : 0}&path=${path ? 1 : 0}`);
    }

    unlockFile(file, scope, revisions = false, path = false) {
        return this.fetch_json('UNLOCK', `/file?id=${file}&scope=${encodeURIComponent(scope)}&revisions=${revisions ? 1 : 0}&path=${path ? 1 : 0}`);
    }

    getTrash(company) {
        if (company == null) {
            return this.get_json('/trash');
        }
        return this.get_json(`/trash?company=${company}`);
    }

    getDrives() {
        return this.get_json('/files?depth=0');
    }

    getUsage(company) {
        if (company == null) {
            return this.get_json('/usage');
        }
        return this.get_json(`/usage?company=${company}`);
    }

    getHistory(file, depth) {
        if (depth == null) {
            return this.get_json(`/history?id=${file}`);
        }
        return this.get_json(`/history?id=${file}&depth=${depth}`);
    }

    changeGroupPermissions(file, group, permissions) {
        return this.post(`/permissions?id=${file}&group=${group}&value=${permissions}`);
    }

    changeUserPermissions(file, user, permissions) {
        return this.post(`/permissions?id=${file}&user=${user}&value=${permissions}`);
    }

    deleteUserPermissions(file, user) {
        return this.delete(`/permissions?id=${file}&user=${user}`);
    }

    deleteGroupPermissions(file, group) {
        return this.delete(`/permissions?id=${file}&group=${group}`);
    }

    getAdminCompanies() {
        return this.get_json('/admin/company');
    }

    getAdminUsers() {
        return this.get_json('/admin/user');
    }

    changeCapacity(owner, capacity) {
        return this.post(`/admin?sid=${owner}&capacity=${capacity}`);
    }

    changeRevisionTime(owner, revision_time) {
        return this.post(`/admin?sid=${owner}&revision_time=${revision_time}`);
    }

    changeRevisionSize(owner, revision_size) {
        return this.post(`/admin?sid=${owner}&revision_size=${revision_size}`);
    }

    changeTrashTime(owner, trash_time) {
        return this.post(`/admin?sid=${owner}&trash_time=${trash_time}`);
    }

    getClients() {
        return this.get_json('/admin/clients');
    }

    getMonitoring() {
        return this.get_json('/admin/monitoring');
    }

    getSettings() {
        return this.get_json('/settings');
    }

    setSettings(key, value, cid) {
        if (cid !== undefined) {
            return this.post(`/settings?cid=${cid}&${key}=${value}`);
        }
        return this.post(`/settings?${key}=${value}`);
    }

    handle_authorization_activation(value) {
        const activated = this.store.activated;
        return new Promise((resolve) => {
            super.handle_authorization_activation(value).finally(() => {
                if (activated !== value) {
                    if (value) {
                        this.wsLogin();
                    } else {
                        this.wsLogout();
                    }
                }
                resolve();
            });
        });
    }
}
